module.exports = __webpack_public_path__ + "factory.svg?6edc36daac9a9e07c7ff9a4b764e525b";


//////////////////
// WEBPACK FOOTER
// ./Content/src/assets/MyProgress/factory.svg
// module id = 306
// module chunks = 1